/* import __COLOCATED_TEMPLATE__ from './direct-to-human-support.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();